import { ReactNode } from 'react';

interface TooltipProps {
  children: ReactNode;
  content: any;
  isShowEmoji?: boolean;
  className?: string;
}

const Tooltip = ({ children, content, isShowEmoji = false, className }: TooltipProps) => {
  return (
    <div className="relative flex items-center group my-1">
      {children}
      <div
        className={
          isShowEmoji ?
            `w-max absolute left-[-10px] hidden group-hover:flex bg-[#6e6659] text-white text-xs rounded-2xl z-10 ${className ? className : ''}`
            :
            `w-max absolute left-[-10px] hidden group-hover:flex bg-tooltipBg text-white bg-darkGrey text-xs rounded-2xl px-2 z-20 top-[-25px] py-1 ${className}`
        }


      >
        {content}
      </div>
    </div >
  );
};

export default Tooltip;